module.exports = __webpack_public_path__ + "static/quoteAlbert-d74d586ae1691c40cd5c7ea7d50879f0.png";